import { useCallback, useState, type FC, type PropsWithChildren } from 'react';

import { MAP_RESOURCE } from '@/assets';
import type { GpsPosition } from '@/features/geo-area/utils/mapMessages';
import {
  Events,
  isMapMessageData
} from '@/features/geo-area/utils/mapMessages';
import { EmbeddedWebpage } from '@/shared/components/embedded/EmbeddedWebpage';

type Props = {
  onGeoAreaClicked?: (id: string) => void;
  onMoveEnd?: (position: GpsPosition) => void;
};

export const GeoAreaMap: FC<PropsWithChildren<Props>> = ({
  onGeoAreaClicked,
  onMoveEnd,
  children,
  ...otherProps
}) => {
  const [initialized, setInitialized] = useState(false);

  const handleMessage = useCallback(
    (message: unknown) => {
      if (isMapMessageData(message)) {
        console.info('received message from map', message);
        if (message.event === Events.ON_INITIALIZED) {
          setInitialized(true);
        } else if (message.event === Events.ON_MARKER_CLICK) {
          onGeoAreaClicked?.(message.payload.marker.id);
        }
        if (message.event === Events.ON_MOVE_END) {
          onMoveEnd?.(message.payload.position);
        }
      }
    },
    [onGeoAreaClicked, onMoveEnd]
  );

  return (
    <EmbeddedWebpage
      srcId={MAP_RESOURCE}
      onError={(e) => console.error(e.target)}
      onMessageReceived={handleMessage}
      openLinksExtern
      {...otherProps}
    >
      {initialized && children}
    </EmbeddedWebpage>
  );
};
